// Endpoint specs:
// https://www.dropbox.com/scl/fi/31nxogj0nap0jy842z4sg/Payment-Page.paper?dl=0&rlkey=sx4z963m428xpb3tpar5sb92y#:uid=478037377368137660714904&h2=Endpoint:-Cancel-Pending-Payme

export const mockCancelPaymentResponse = {
  // // SUCCESS
  success: true,
  // // ERROR: GENERAL
  // success: false,
  // errorCode: "general",
  // // ERROR: PAYMENT COMPLETE
  // success: false,
  // errorCode: "payment_already_complete",
};
